import Promo from "../../../../../Data/Promo";
import { useState, useEffect } from "react";
import useFetch, { FetchRequest } from "../../../../../_helpers/UseFetchHook";
import { Constants } from "../../../../../_helpers/Constants";


export type PromoFetchQuery = {
  companyId: number;
  promoCodeName: string;
}

export type PromoFetchResponse = {
  success: boolean;
  message: string;
  promo: Promo;
}

const UseGetPromoByName = (promoQuery?: PromoFetchQuery) => {
  const url = `${Constants.apiUrl}/api/v1.0/promos/`;

  const [data, setData] = useState<PromoFetchResponse | null>(null);
  const [error, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [fetchRequest, setFetchRequest] = useState<FetchRequest>();
  const fetchResponse = useFetch(fetchRequest); // Fetch Data Custom Hook

  useEffect(() => {
    if (promoQuery) {
      let queryUrl: string = url + `${promoQuery.companyId}/get-by-name/${promoQuery.promoCodeName}`;

      setFetchRequest({
        url: queryUrl,
        method: 'GET'
      });
    }
  }, [promoQuery]);

  useEffect(() => {
    if (fetchResponse.data) {
      const response: PromoFetchResponse = fetchResponse.data;
      setData(response);
    }
  }, [fetchResponse.data]);

  useEffect(() => {
    if (fetchResponse.error) {
      setError(fetchResponse.error)
    }
  }, [fetchResponse.error]);

  useEffect(() => {
    setIsLoading(fetchResponse.isLoading);
  }, [fetchResponse.isLoading]);

  return ({ data, error, isLoading });
}

export default UseGetPromoByName;